import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import shortid from "shortid";
import {
  Autocomplete,
  Box,
  Button,
  CardContent,
  Chip,
  CircularProgress,
  DatePicker,
  FormControl,
  FullscreenDialog,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Tab,
  TabPanel,
  Tabs,
  TextareaAutosize,
  TextField,
  Tooltip,
  Typography,
} from "../../../components";
import { useImportContext } from "../../../contexts/import.context";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { AddLayout } from "../../../layouts";
import {
  AdzapService,
  AtivoServicoService,
  CondicoesPagamentoService,
  ConfiguracoesChecklistService,
  ConfiguracoesOrdemServicoService,
  EmailPersonalizadoService,
  EnderecosEstoqueService,
  history,
  ImpressoraService,
  MeioPagamentoService,
  MensagemPersonalizadaService,
  NotificacaoService,
  notification,
  OrcamentoServicosService,
  OrdemServicoService,
  OrdemServicosItensService,
  OrdemServicosServicosService,
  OrdemServicosStatusPersonalizadosService,
  PessoaService,
  ProdutosService,
  SessionService,
  StorageService,
  TabelaVendaService,
  UsuarioService,
} from "../../../services";
import OrdemServicosPagamentosService from "../../../services/api/ordem-servicos-pagamentos.service";
import {
  encrypt,
  formatCelular,
  formatDate,
  formatPrecisaoFloat,
  montarFiltroPessoa,
  responseErros,
  userLogs,
  voltar,
} from "../../../utils";
import AddPessoas from "../../pessoas/addPessoa/addPessoa.view";
import {
  OrdemServico,
  OrdemServicoPrintEntity,
  TermoAceitePrintEntity,
} from "../entities";
import { isAtivoVeiculo } from "../entities/campos-veiculo";
import {
  calculaDiferencaDias,
  possuiChecklistLancado,
} from "./add-ordem-servico";
import {
  AtivosOrdemServico,
  ChecklistOrdemServico,
  HistoricoAtivosDialog,
  ListPesquisaSatisfacaoOS,
  OrdemServicoListaPagamentos,
  OrdemServicoListaProdutos,
  OrdemServicoListaServicos,
  ReciboPrintLayout,
  ResumoTotal,
} from "./components";
import EnvioWhatsappDialog from "./components/dialogComponents/EnvioWhatsappDialog";
import HistorioClienteDialog from "./components/dialogComponents/historico-cliente-dialog.component";
import { ordemServicoValidator } from "./middlewares";

const ordemServicoService = new OrdemServicoService();
const pessoaService = new PessoaService();
const ativoServicoService = new AtivoServicoService();
const sessionService = new SessionService();
const produtosService = new ProdutosService();
const usuariosService = new UsuarioService();
const ordemServicoItensService = new OrdemServicosItensService();
const ordemServicoPagamentosService = new OrdemServicosPagamentosService();
const ordemServicoServicosService = new OrdemServicosServicosService();
const meioPagamentoService = new MeioPagamentoService();
const condicoesPagamentoService = new CondicoesPagamentoService();
const tabelaVendaService = new TabelaVendaService();
const configuracoesOrdemServicoService = new ConfiguracoesOrdemServicoService();
const orcamentoServicosService = new OrcamentoServicosService();
const ordemServicosStatusPersonalizadosService =
  new OrdemServicosStatusPersonalizadosService();
const adzapService = new AdzapService();
const mensagemPersonalizadaService = new MensagemPersonalizadaService();
const configuracoesChecklistService = new ConfiguracoesChecklistService();
const impressoraService = new ImpressoraService();
const storageService = new StorageService();
const enderecosEstoqueService = new EnderecosEstoqueService();
const notificacaoService = new NotificacaoService();
const emailPersonalizadoService = new EmailPersonalizadoService();

let ordemServicoEntity = {
  dataAbertura: formatDate.toSend(new Date()),
  dataFechamento: null,
  status: "ABERTO",
};

let ordemServicoPrintEntity = {};

function tabProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function EndAdornmentCliente({ params, loading, clienteSelecionado }) {
  return (
    <Box
      sx={{
        position: "absolute",
        right: "1rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      {loading ? (
        <CircularProgress color="inherit" size={20} sx={{ ml: 1 }} />
      ) : null}

      <Box
        sx={{
          position: "relative",
          display: "flex",
          width: "4.5rem",
          height: "2rem",
        }}
      >
        {params.InputProps.endAdornment}
      </Box>

      {clienteSelecionado?.celular ? (
        <Tooltip
          arrow
          placement="bottom"
          title={
            <div className="modelo-div-title" style={{ fontSize: "12px" }}>
              {formatCelular(clienteSelecionado?.celular)}
            </div>
          }
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              ml: 1,
              cursor: "default",
              userSelect: "none",
            }}
            onMouseDown={(e) => e.preventDefault()}
            tabIndex={-1}
            aria-hidden={true}
          >
            <i
              className="ph-fill ph-phone"
              style={{
                fontSize: 20,
                position: "relative",
                top: "1px",
              }}
            ></i>
          </Box>
        </Tooltip>
      ) : null}
    </Box>
  );
}

const AddOrdemServico = ({ match }) => {
  const ultimaParteCaminho = window.location.pathname.split("/").pop();
  const documentoImportado = ultimaParteCaminho.includes("importar");
  const id = !documentoImportado && match.params.id;

  const printComponentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const [userLog, setUserLog] = useState({});
  const [ordemServico, setOrdemServico] = useState({ ...ordemServicoEntity });
  const [clienteList, setClienteList] = useState([]);
  const [isProdutoEdit, setIsProdutoEdit] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [servicoList, setServicoList] = useState([]);
  const [prestadoresList, setPrestadoresList] = useState([]);
  const [vendedoresList, setVendedoresList] = useState([]);
  const [usuariosList, setUsuariosList] = useState([]);
  const [produtoList, setProdutoList] = useState([]);
  const [enderecosEstoqueList, setEnderecosEstoqueList] = useState([]);
  const [listaOrdemServicoProdutos, setListaOrdemServicoProdutos] = useState(
    [],
  );
  const [listaOrdemServicoServicos, setListaOrdemServicoServicos] = useState(
    [],
  );
  const [campoChave, setCampoChave] = useState(null);
  const [produto, setProduto] = useState(null);
  const [produtosSimilares, setProdutosSimilares] = useState([]);
  const [configuracoes, setConfiguracoes] = useState({});
  const [configuracaoOrdemServico, setConfiguracaoOrdemServico] = useState({});
  const [acrescimoPagamento, setAcrescimoPagamento] = useState(null);
  const [listaOrdemServicoPagamentos, setListaOrdemServicoPagamentos] =
    useState([]);
  const [listaOrdemServicoPesquisas, setListaOrdemServicoPesquisas] = useState(
    [],
  );
  const [gerarPagamentos, setGerarPagamentos] = useState({});
  const [meioPagamentoSelecionado, setMeioPagamentoSelecionado] =
    useState(null);
  const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [meiosPagamentoCliente, setMeiosPagamentoCliente] = useState(null);
  const [condicaoPagParcelaList, setCondicaoPagParcelaList] = useState([]);
  const [condicaoPagamentoList, setCondicaoPagamentoList] = useState([]);
  const [condicaoSelecionada, setCondicaoSelecionada] = useState(null);
  const [statusList, setStatusList] = useState([]);
  const [habilitarPagamentoPrazo, setHabilitarPagamentoPrazo] = useState(false);
  const [openHistoricoClienteDialog, setOpenHistoricoClienteDialog] =
    useState(false);
  const [openHistoricoAtivosDialog, setOpenHistoricoAtivosDialog] =
    useState(false);
  const [openDialogEnvioWhatsapp, setOpenDialogEnvioWhatsapp] = useState(false);
  const [ordemServicos, setOrdemServicos] = useState([]);
  const [orcamentoServicoVinculado, setOrcamentoServicoVinculado] =
    useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [tabelas, setTabelas] = useState({
    cliente: null,
    grupoPessoa: null,
    todosProdutos: null,
  });
  const [isCadastroPessoaDialogOpen, setIsCadastroPessoaDialogOpen] =
    useState(false);
  const [envioMensagemManual, setEnvioMensagemManual] = useState(false);
  const [acessoriosAtivo, setAcessoriosAtivo] = useState([]);
  const [locaisAvaria, setLocaisAvaria] = useState([]);
  const [tiposAvaria, setTiposAvaria] = useState([]);
  const [reciboPagamentos, setReciboPagamentos] = useState([]);
  const [avariaSelecionada, setAvariaSelecionada] = useState(0);
  const [checklistPreenchido, setChecklistPreenchido] = useState(false);
  const [abaValue, setAbaValue] = useState(0);
  const dataAberturaResetRef = useRef(0);
  const { initialCollapses } = useImportContext();

  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("ordem-servicos-visualizar");
  const [
    permissaoAlterarVendedor,
    permissaoAlterarValorProduto,
    permissaoAlterarValorServico,
    permissaoAlterarDataAberturaRetroativa,
  ] = [
    permissoesHelper.temPermisao("alterar-vendedor-por-item"),
    permissoesHelper.temPermisao("alterar-valor-produto-ordem-servicos"),
    permissoesHelper.temPermisao("alterar-valor-servico-ordem-servicos"),
    permissoesHelper.temPermisao("data-abertura-retroativa-ordem-servicos"),
  ];
  const permissaoEditarChecklist = permissoesHelper.getPermisoesModulo(
    "ordem-servicos-editar-checklist",
  );
  const checklistSomenteLeitura =
    !!id && checklistPreenchido && !permissaoEditarChecklist?.habilitado;
  const ordemServicoValidatorService = ordemServicoValidator(
    documentoImportado,
    id,
  );

  const inputCliente = useRef();
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const dadosEmpresa = sessionService.getEmpresaAndUsuario();

  const tiposPessoa = [
    {
      tipoId: 1,
      setLista: (dados) => setClienteList(dados),
    },
  ];

  useEffect(() => {
    buscarDadosIniciais();
  }, [id]);

  const buscarDadosIniciais = async () => {
    await buscarMeiosPagamento();
    if (!id && !documentoImportado) {
      ordemServicoEntity = new OrdemServico({
        dataAbertura: formatDate.toSend(new Date()),
        status: "ABERTO",
      });
      const configuracao = await buscarSerieDocumentoConfiguracao();
      ordemServicoEntity.setSerieDocumento(configuracao?.serieDocumento);
      ordemServicoEntity.setConfiguracaoOrdemServicoId(configuracao?.id);
      ordemServicoEntity.setDescricaoServicoFixa(configuracao);
      setOrdemServico({ ...ordemServicoEntity });
      buscarConfiguracaoChecklist();
      buscarAtivos();
    } else {
      await buscarOrdemServico();
      if (id) buscarSerieDocumentoConfiguracao();
    }
    await buscarUsuarios();
    await buscarStatusPersonalizados();
    buscarCondicoesPagamento();
    buscarConfiguracao();
    buscarPrestadoresServico();
    buscarVendedores();
    buscarEnderecosEstoque();
  };

  const buscarConfiguracaoChecklist = async (avarias = [], acessorios = []) => {
    setLoading(true);
    const response = await configuracoesChecklistService.getAll();
    if (!response.isAxiosError) {
      const configuracao = response.data || {};
      const mapaAvarias = new Map();
      avarias.forEach((item) => {
        if (item?.componenteId) {
          mapaAvarias.set(item.componenteId, item);
        }
      });

      const mapaAcessorios = new Map();
      acessorios.forEach((item) => {
        if (item?.acessorioId) {
          mapaAcessorios.set(item.acessorioId, item);
        }
      });

      setTiposAvaria(
        (configuracao.tipos || []).map((tipo) => ({
          ...tipo,
          nome: tipo.descricao,
        })),
      );

      setAcessoriosAtivo(
        (configuracao.acessorios || []).map((acessorio) => ({
          ...acessorio,
          contem: mapaAcessorios.has(acessorio.id)
            ? mapaAcessorios.get(acessorio.id).contem
            : false,
        })),
      );

      const locaisMapeados = (configuracao.locais || []).map((local) => ({
        ...local,
        componentes: (local.componentes || []).map((componente) => ({
          ...componente,
          tipoId: mapaAvarias.has(componente.id)
            ? mapaAvarias.get(componente.id).tipoId
            : null,
        })),
      }));

      setLocaisAvaria(locaisMapeados);
      setAvariaSelecionada(locaisMapeados.length ? 0 : null);
    } else {
      responseErros(response);
    }

    setLoading(false);
  };

  const buscarSerieDocumentoConfiguracao = async () => {
    const response = await configuracoesOrdemServicoService.getAll();
    if (!response.isAxiosError) {
      setConfiguracaoOrdemServico(response.data[0] || {});
      return response.data[0];
    } else {
      responseErros(response);
    }
  };

  const buscarConfiguracao = () => {
    if (dadosEmpresa.empresa?.configuracoes) {
      const data = dadosEmpresa.empresa.configuracoes;
      setConfiguracoes(data);
    }
  };

  const buscarOrdemServico = async () => {
    setLoading(true);
    if (id) {
      const response = await ordemServicoService.getById(id);
      if (!response.isAxiosError) {
        const data = response.data;
        const ativosSalvos = data.ativos || [];
        ordemServicoEntity = new OrdemServico(data, id);
        ordemServicoEntity.setStatusInicial(data.status);
        ordemServicoEntity.initTotalPagamentos(data?.pagamentos || []);
        setOrdemServico({ ...ordemServicoEntity, statusInicial: data.status });
        setListaOrdemServicoPesquisas(data?.pesquisas || []);
        setListaOrdemServicoPagamentos(data?.pagamentos || []);
        setChecklistPreenchido(possuiChecklistLancado(data));
        buscarOrcamentoServicoVinculado(data?.orcamentoServicoId);
        buscarConfiguracaoChecklist(
          data?.avarias || [],
          data?.acessorios || [],
        );
        await buscarDadosClientes(data?.clienteId);
        await buscarAtivosParaEdicao(ativosSalvos);
        if (data?.itens?.length > 0) {
          const itens = data?.itens.map((item) => ({
            ...item,
            totalItem:
              item.quantidade * item.valorUnitario -
              (item.desconto || 0) +
              (item.despesas || 0),
          }));
          setListaOrdemServicoProdutos(itens);
        }
        if (data?.servicos?.length > 0) {
          const itens = data?.servicos.map((item) => ({
            ...item,
            totalItem: item.quantidade * item.valor - (item.desconto || 0),
          }));
          setListaOrdemServicoServicos(itens);
        }
      } else {
        responseErros(response);
      }
    } else await importarOrcamentoServico(window?.ordemServicoEntity);
    setLoading(false);
  };

  const buscarOrcamentoServicoVinculado = async (orcamentoServicoId) => {
    if (!orcamentoServicoId) {
      setOrcamentoServicoVinculado(null);
      return;
    }
    const response = await orcamentoServicosService.getById(orcamentoServicoId);
    if (!response.isAxiosError) {
      setOrcamentoServicoVinculado(response.data);
    } else {
      responseErros(response);
    }
  };

  async function importarOrcamentoServico(orcamentoServico) {
    const orcamentoServicoEntity = new OrdemServico(orcamentoServico);
    orcamentoServicoEntity.insertDadosOrdemServico(
      orcamentoServico,
      orcamentoServico.id,
      true,
    );
    orcamentoServicoEntity.setOrcamentoServicoId(orcamentoServico.id);
    const configuracao = await buscarSerieDocumentoConfiguracao();
    orcamentoServicoEntity.setSerieDocumento(configuracao?.serieDocumento);
    orcamentoServicoEntity.setConfiguracaoOrdemServicoId(configuracao?.id);
    orcamentoServicoEntity.setDescricaoServicoFixa(configuracao);
    if (orcamentoServico.servicos?.length > 0) {
      const servicos = orcamentoServico?.servicos.map((item) => ({
        ...item,
        id: shortid.generate(),
      }));
      orcamentoServicoEntity.setChangeServicos(servicos);
      setListaOrdemServicoServicos(servicos);
    }
    if (orcamentoServico.itens?.length > 0) {
      const itens = orcamentoServico?.itens.map((item) => ({
        ...item,
        id: shortid.generate(),
        totalItem:
          item.quantidade * item.valorUnitario -
          (item.desconto || 0) +
          (item.despesas || 0),
      }));
      setListaOrdemServicoProdutos(itens);
      orcamentoServicoEntity.setChangeItens(itens);
    }
    if (orcamentoServico.pagamentos?.length > 0) {
      const pagamentos = orcamentoServico?.pagamentos.map((item) => ({
        ...item,
        id: shortid.generate(),
      }));
      let pagamentosOrdemServico = pagamentos;
      if (!dadosEmpresa.empresa.configuracoes.exibirPagamentoSemBaixa) {
        pagamentosOrdemServico = pagamentos.filter(
          (item) => item.meioPagamentoSelecionado?.baixaAutomatica,
        );
      }

      setListaOrdemServicoPagamentos(pagamentosOrdemServico);
      orcamentoServicoEntity.setChangePagamentos(pagamentosOrdemServico);
    }
    if (orcamentoServico.cliente) {
      await insertClienteImportacao(
        orcamentoServico.cliente,
        orcamentoServicoEntity,
      );
    }
    setOrdemServico({ ...orcamentoServicoEntity });
    ordemServicoEntity = orcamentoServicoEntity;
  }

  async function insertClienteImportacao(cliente, orcamentoServicoEntity) {
    orcamentoServicoEntity.setHandleChangeAutoComplete("clienteId", cliente);
    setOrdemServico((prevState) => ({
      ...orcamentoServicoEntity,
      statusInicial: prevState.statusInicial,
    }));
    setClienteSelecionado(cliente);
    await buscarDadosClientes(cliente?.id);
    if (cliente?.clientes?.length) {
      buscarTodasTabelasVenda(
        cliente?.id,
        cliente?.clientes?.[0]?.grupoPessoaId,
      );
    } else {
      setMeiosPagamentoCliente(null);
    }
  }

  const filtrarAtivoVeiculo = (lista) => {
    const veiculo = lista.find(isAtivoVeiculo);
    return veiculo ? [veiculo] : lista;
  };

  const buscarAtivos = async () => {
    const result = await ativoServicoService.getAll();
    if (!result.isAxiosError) {
      const listaDeAtivos = filtrarAtivoVeiculo(
        result.data.filter((ativo) => !!ativo?.ativado),
      );
      buscarCampoChave(listaDeAtivos);
      ordemServicoEntity.setAtivos(listaDeAtivos);
      setOrdemServico({ ...ordemServicoEntity });
    } else {
      responseErros(result);
    }
  };

  const buscarCampoChave = (listaDeAtivos) => {
    for (const ativo of listaDeAtivos) {
      if (ativo?.camposPersonalizados?.length) {
        const chave = ativo.camposPersonalizados.find(
          (campo) => campo.campoChave,
        );
        setCampoChave(chave);
        break;
      }
    }
  };

  const buscarEnderecosEstoque = () => {
    const filter = {
      nonPaginated: true,
    };
    enderecosEstoqueService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setEnderecosEstoqueList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarAtivosParaEdicao = async (ativosSalvos) => {
    const result = await ativoServicoService.getAll();
    if (!result.isAxiosError) {
      const listaDeAtivos = result.data.filter((ativo) => !!ativo?.ativado);
      ordemServicoEntity.setAtivosComValoresSalvos(listaDeAtivos, ativosSalvos);
      setOrdemServico((prevState) => ({
        ...ordemServicoEntity,
        statusInicial: prevState.statusInicial,
      }));
    } else {
      responseErros(result);
    }
  };

  const buscarStatusPersonalizados = async function () {
    setLoading(true);
    const result = await ordemServicosStatusPersonalizadosService.getAll();
    if (!result.isAxiosError) {
      const colunasCompletas = [
        { id: null, descricao: "ABERTO", cor: "#4FBB53" },
        ...result.data,
        { id: null, descricao: "FECHADO", cor: "#004780" },
        { id: null, descricao: "CANCELADO", cor: "#DC3545" },
      ];
      const statusListCompleto = colunasCompletas.map((col) => ({
        ...col,
        id: col.id,
        status: col.descricao,
      }));
      setStatusList(statusListCompleto);

      if (ordemServicoEntity?.statusPersonalizadoId) {
        const statusPersonalizado = statusListCompleto.find(
          (status) => status.id == ordemServicoEntity.statusPersonalizadoId,
        );
        setOrdemServico((prevState) => ({
          ...prevState,
          status: statusPersonalizado?.status ?? prevState.status,
          statusInicial: statusPersonalizado?.status ?? prevState.statusInicial,
        }));
      }
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarPrestadoresServico = () => {
    const filtro = {
      nonPaginated: true,
      tiposPessoaId: 5,
      attributes: ["id", "nomeRazaoSocial"],
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setPrestadoresList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarVendedores = () => {
    const config = dadosEmpresa.empresa.configuracoes;
    if (id || config?.vendedorPorItemServico) {
      const filtro = {
        nonPaginated: true,
        tiposPessoaId: 4,
        vendedor: true,
        ativado: true,
        attributes: ["id", "nomeRazaoSocial"],
      };
      pessoaService.getAll(filtro).then((result) => {
        if (!result.isAxiosError) {
          setVendedoresList(result.data);
        } else {
          responseErros(result);
        }
      });
    } else {
      const usuario = {
        id: null,
        nomeRazaoSocial: dadosEmpresa.usuario.nome,
      };
      setVendedoresList([usuario]);
    }
  };

  const buscarUsuarios = async () => {
    const result = await usuariosService.getAllFiltroAvancado({
      nonPaginated: true,
    });
    if (!result.isAxiosError) {
      setUsuariosList(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const removerServicoCadastrado = async (idServico) => {
    setLoading(true);
    const res = await ordemServicoServicosService.deletarEmLote({
      idItens: [idServico],
    });
    if (!res.isAxiosError) {
      notification.deletadoSucesso();
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const removerProdutoCadastrado = async (idProduto) => {
    setLoading(true);
    const res = await ordemServicoItensService.deletarEmLote(idProduto);
    if (!res.isAxiosError) {
      notification.deletadoSucesso();
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const removerPagamentoCadastrado = async (idPagamentos) => {
    setLoading(true);
    const res = await ordemServicoPagamentosService.deletarEmLote({
      idPagamentos,
    });
    if (!res.isAxiosError) {
      buscarPagamentosCadastrados();
      notification.deletadoSucesso();
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const buscarPagamentosCadastrados = () => {
    const filter = {
      nonPaginated: true,
      ordemServicoId: id,
    };
    ordemServicoPagamentosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        ordemServicoEntity.setChangePagamentos(res.data);
        setOrdemServico((prevState) => ({
          ...ordemServicoEntity,
          statusInicial: prevState.statusInicial,
        }));
        setListaOrdemServicoPagamentos(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarMeiosPagamento = async (filtros) => {
    const filtro = {
      ...filtros,
      ativado: true,
      nonPaginated: true,
    };
    meioPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setMeioPagamentoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarCondicoesPagamento = () => {
    const filtro = {
      nonPaginated: true,
      ativado: true,
    };
    condicoesPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setCondicaoPagamentoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarDocumentosCliente = async (clienteId) => {
    setLoadingHistorico(true);
    ordemServicoService
      .getAllFiltroAvancado({ clienteId })
      .then((result) => {
        if (!result.isAxiosError) {
          if (result.data.rows?.length) {
            setOrdemServicos(result.data.rows);
            setTotalItems(result.data.count);
          } else {
            setOrdemServicos([]);
            setTotalItems(0);
          }
        } else {
          responseErros(result);
        }
      })
      .finally(() => setLoadingHistorico(false));
  };

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(ordemServicoEntity);
    setUserLog(logs);
  }

  const handleDateChange = (fieldName, date) => {
    const isValidDate = (d) => d instanceof Date && !isNaN(d);
    if (!date || !isValidDate(date) || date.getFullYear() < 2000) {
      date = "Invalid Date";
    }
    if (
      fieldName === "dataAbertura" &&
      isValidDate(date) &&
      !permissaoAlterarDataAberturaRetroativa
    ) {
      const selected = new Date(date);
      const hoje = new Date();
      selected.setHours(0, 0, 0, 0);
      hoje.setHours(0, 0, 0, 0);
      if (selected < hoje) {
        notification.alertaGenericos(
          "Você não tem permissão para informar data de abertura retroativa",
        );
        date = hoje;
        dataAberturaResetRef.current += 1;
      }
    }

    ordemServicoEntity.setHandleChangeDate(fieldName, date);
    setOrdemServico((prevState) => ({
      ...ordemServicoEntity,
      statusInicial: prevState.statusInicial,
    }));
  };

  const atualizarEntidadePrint = () => {
    const dadosEmpresaRelatorio = sessionService.getEmpresaRelatorio();
    ordemServicoPrintEntity = new OrdemServicoPrintEntity(
      dadosEmpresaRelatorio,
      ordemServicoEntity.pagamentos,
      ordemServicoEntity.servicos,
      meioPagamentoList,
      prestadoresList,
      clienteSelecionado,
    );
  };

  async function modalConfirmacaoFechamento() {
    const props = {
      title: "Fechamento de Ordem de Serviço realizado",
      text: `#${ordemServicoEntity.numeroDocumento}`,
      icon: "success",
      confirmButtonText: "IMPRIMIR",
      cancelButtonText: "EMAIL",
      showCancelButton: true,
      showCloseButton: true,
      closeButtonHtml:
        "<i class='ph-bold ph-x' style='font-size: 21px' aria-hidden='true'></i>",
      dangerMode: true,
    };
    if (dadosEmpresa.empresa?.whatsappSimples) {
      props.width = "min(38rem, calc(100vw - 2rem))";
      props.denyButtonText = "WHATSAPP";
      props.showDenyButton = true;
    }
    const confirmacaoAlerta = await notification.confirmacaoGenericos(props);
    if (confirmacaoAlerta.isConfirmed) {
      await buscarOS();
      initialCollapses();
      handleCancelar();
      history.push("/faturamento/ordem-servicos");
    } else if (confirmacaoAlerta?.isDenied) {
      atualizarEntidadePrint();
      setOpenDialogEnvioWhatsapp(true);
    } else if (confirmacaoAlerta?.dismiss === "cancel") {
      await enviarEmail();
      initialCollapses();
      handleCancelar();
      history.push("/faturamento/ordem-servicos");
    } else {
      initialCollapses();
      handleCancelar();
      history.push("/faturamento/ordem-servicos");
    }
  }

  async function modalConfirmacaoWhatsapp(cliente, texto) {
    const props = {
      title: "Mudança de status realizada",
      text: `Deseja enviar uma mensagem de confirmação de status para o cliente?`,
      icon: "success",
      confirmButtonText: "CONFIRMAR",
      cancelButtonText: "FECHAR",
      showCancelButton: true,
      dangerMode: true,
    };
    const confirmacaoAlerta = await notification.confirmacaoGenericos(props);
    if (confirmacaoAlerta.isConfirmed) {
      const result = await adzapService.enviarMensagem({
        number: cliente?.celular || "",
        type: "text",
        text: texto?.data,
      });

      if (!result.isAxiosError) {
        notification.sucessoGenericos("Documento enviado com sucesso!");
        history.push("/faturamento/ordem-servicos");
      } else {
        responseErros(result);
      }
    }
  }

  function simplificarNome(nomeCompleto) {
    const sobrenomes = nomeCompleto.split(" ");
    const primeiroNome = sobrenomes[0],
      qtdNomes = sobrenomes.length;
    let ultimoNome = sobrenomes[qtdNomes - 1];

    if (qtdNomes > 1) {
      const particulas = ["de", "da", "do", "dos", "das"];
      const penultimo = sobrenomes[qtdNomes - 2].toLowerCase();
      if (particulas.includes(penultimo)) {
        ultimoNome = sobrenomes[qtdNomes - 2] + " " + ultimoNome;
      }
    } else {
      return primeiroNome;
    }

    return `${primeiroNome} ${ultimoNome}`;
  }

  function gerarLinkAgendamento(data) {
    const baseUrl = window.location.origin;
    const base = {
      empresaId: dadosEmpresa.empresa?.id,
      nomeFantasia: dadosEmpresa.empresa?.fantasia,
      cnpjCpf: dadosEmpresa.empresa?.cnpjCpf,
      servicoId: data?.id,
      chaveAtivo: data?.ativo,
      clienteId: ordemServicoEntity?.clienteId,
      clienteNome: simplificarNome(ordemServicoEntity?.clienteNome),
      celular: ordemServicoEntity?.clienteNome,
      prestadorServicoId: data?.prestadorServicoId,
      diasSemanaFuncionamento:
        dadosEmpresa.empresa.configuracoes.diasSemanaFuncionamento,
      intervaloAgendamentos:
        dadosEmpresa.empresa.configuracoes.intervaloAgendamentos,
    };
    const basicData = encrypt(base);
    return `${baseUrl}/cadastros/agendamento-servico/${basicData}`;
  }

  async function enviarMensagemServicoRecorrente(servico, contexto) {
    const getPrimeiroNome = (nomeCompleto) => nomeCompleto?.split(" ")[0] || "";
    const nomeCompletoCliente = ordemServicoEntity?.clienteNome;
    const dataVencimento = new Date();
    dataVencimento.setHours(0, 0, 0, 0);
    dataVencimento.setDate(dataVencimento.getDate() + servico.prazoRecorrencia);
    const dataEnvioMensagem = new Date(),
      diasAntecedencia = Math.ceil(servico.tempoAntecedencia / 24);
    dataEnvioMensagem.setHours(0, 0, 0, 0);
    dataEnvioMensagem.setDate(dataVencimento.getDate() - diasAntecedencia);
    const quantidadeDias = calculaDiferencaDias(new Date(), dataEnvioMensagem);
    const ativo = ordemServicoEntity.ativos[0].valoresCampos.find(
      (campo) => campo.campoChave,
    ).valor;
    const linkAgendamento = gerarLinkAgendamento({ ...servico, ativo });

    const texto = await mensagemPersonalizadaService.getMensagem({
      contexto,
      apelidoFantasia: dadosEmpresa.empresa.fantasia,
      primeiroNomeCliente: getPrimeiroNome(nomeCompletoCliente),
      nomeCompletoCliente,
      ativo,
      dataVencimento: format(dataVencimento, "dd/MM/yyyy"),
      nomeServico: servico.descricao,
      dataUltimaRecorrencia: format(new Date(), "dd/MM/yyyy"),
      quantidadeDias,
      ordemServico: `${ordemServicoEntity?.serieDocumento}-${ordemServicoEntity?.numeroDocumento}`,
      linkAgendamento,
    });

    if (texto.isAxiosError) {
      throw texto;
    }

    const mensagemContexto = await mensagemPersonalizadaService.getAll({
      contexto: "servico-recorrente",
    });
    const anexo = mensagemContexto.data.rows[0].anexo;

    return { mensagem: texto.data, anexo };
  }

  async function buscarMensagemServicoRecorrente() {
    if (
      (dadosEmpresa.empresa.whatsappSimples ||
        dadosEmpresa.empresa.whatsappAvancado) &&
      ordemServicoEntity.clienteNumero
    ) {
      const servicosLembrete = ordemServicoEntity.servicos.filter(
        (item) => item.tempoAntecedencia,
      );
      for (let i = 0; i < servicosLembrete.length; i++) {
        const servico = servicosLembrete[i];
        const { mensagem, anexo } = await enviarMensagemServicoRecorrente(
          servico,
          "servico-recorrente",
        );
        servico.setMensagem(mensagem);
        servico.setAnexo(anexo);
      }
    }
  }

  async function filtrarImagensChecklist() {
    const nomeArquivos = [];
    const imagensUpload = [];

    for (const image of ordemServicoEntity.imagens || []) {
      if (image && typeof image === "string" && image.startsWith("data:")) {
        imagensUpload.push(image);
      } else if (image && typeof image === "string") {
        nomeArquivos.push(image.substring(image.lastIndexOf("/") + 1));
      }
    }

    if (imagensUpload.length > 0) {
      const formData = new FormData();
      for (let i = 0; i < imagensUpload.length; i++) {
        const dataUrl = imagensUpload[i];
        const blob = await (await fetch(dataUrl)).blob();
        formData.append(
          "image",
          blob,
          `imagem-${i}-${shortid.generate()}.foto-ordem-servico`,
        );
      }

      const resStorage = await storageService.addImages(formData);
      if (resStorage.isAxiosError) {
        throw resStorage;
      }

      if (Array.isArray(resStorage.data)) {
        const nomesUpload = resStorage.data.map((item) => item.fileName);
        nomeArquivos.push(...nomesUpload);
      }
    }

    return nomeArquivos;
  }

  async function montarOrdemServicoBodyComImagens() {
    const ordemServicoBody = { ...ordemServicoEntity };
    const nomesArquivos = await filtrarImagensChecklist();
    ordemServicoBody.imagens = nomesArquivos.map((fileName, index) => ({
      nomeArquivo: fileName,
      ordem: index,
    }));
    return ordemServicoBody;
  }

  const handlePrintReciboA4 = useReactToPrint({
    content: () => printComponentRef.current,
    pageStyle: `
        @page {
          size: auto;
          margin: 8mm;
        }
      `,
  });

  async function buscarModeloRecibo80mm(documento) {
    setLoading(true);
    const result = await ordemServicoService.getModeloRecibo80mm({
      documento,
      cliente: clienteSelecionado,
      pagamentos: reciboPagamentos,
      empresa: dadosEmpresa.empresa,
    });
    setLoading(false);
    if (!result.isAxiosError) {
      if (configuracoes?.impressaoDiretaReciboServico) {
        print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function modalSelecaoModeloImpressao(documento) {
    const retornoAlerta = await notification.confirmacaoGenericos({
      title: "Selecione um modelo de impressão",
      icon: "info",
      confirmButtonText: `
        <i class="ph-fill ph-article" style="font-size:40px; color: white;"></i> <p style="margin: 0">A4</p>
      `,
      cancelButtonText: `
        <i class="ph-fill ph-scroll" style="font-size:40px; color: white;"></i> <p style="margin: 0">80mm</p>
      `,
      showCancelButton: true,
    });
    if (retornoAlerta.isConfirmed) {
      handlePrintReciboA4();
      return;
    }
    if (retornoAlerta.dismiss === "cancel") {
      await buscarModeloRecibo80mm(documento);
      return;
    }

    setLoading(false);
  }

  const validarImpressaoRecibo = async (ordemServico) => {
    if (configuracoes?.impressaoReciboServico && reciboPagamentos.length) {
      const modeloPadrao = configuracoes?.modeloImpressaoPadraoReciboServico;
      if (modeloPadrao) {
        if (modeloPadrao === "80MM") {
          const documento = `${ordemServico.serieDocumento}-${ordemServico.numeroDocumento}`;
          await buscarModeloRecibo80mm(documento);
        } else {
          handlePrintReciboA4();
        }
      } else {
        const documento = `${ordemServico.serieDocumento}-${ordemServico.numeroDocumento}`;
        await modalSelecaoModeloImpressao(documento);
      }
    }
  };

  const handleSubmit = async (indiceSelecionado) => {
    setLoading(true);
    ordemServicoValidatorService
      .validate(ordemServicoEntity, {
        abortEarly: false,
        context: { locaisAvaria, checklistSomenteLeitura },
      })
      .then(async () => {
        let openModalFechamento = false;
        if (id) {
          if (
            ordemServico?.status === "FECHADO" &&
            formatPrecisaoFloat(ordemServico?.totalOrdemServico) -
              (formatPrecisaoFloat(ordemServico?.totalPagamentos) || 0) >
              0
          ) {
            setHabilitarPagamentoPrazo(true);
            setLoading(false);
            navegarAtePagamentos();
            return notification.alertaGenericos(
              "Valor total da ordem de serviço difere do total dos pagamentos",
            );
          } else if (
            ordemServico?.status === "FECHADO" &&
            formatPrecisaoFloat(ordemServico?.totalOrdemServico) -
              (formatPrecisaoFloat(ordemServico?.totalPagamentos) || 0) ===
              0
          ) {
            openModalFechamento = true;
            if (ordemServicoEntity?.clienteCelular) {
              await buscarMensagemServicoRecorrente();
            }
          }
          const statusChanged =
            ordemServico?.status !== "FECHADO" &&
            statusSelectValue !== ordemServico?.statusInicial;
          const ordemServicoBody = await montarOrdemServicoBodyComImagens();
          const response = await ordemServicoService.atualizar(
            id,
            ordemServicoBody,
          );
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            if (openModalFechamento) modalConfirmacaoFechamento();
            else {
              if (statusChanged) enviarMensagem(response.data, true);
              await validarImpressaoRecibo(ordemServico);

              setReciboPagamentos([]);
              buscarOrdemServico();
            }
          } else {
            responseErros(response);
            formatarErroPagamentos(response?.response?.data);
          }
        } else {
          const ordemServicoBody = await montarOrdemServicoBodyComImagens();
          const response = await ordemServicoService.cadastrar(
            ordemServicoBody,
          );
          setLoading(false);
          if (!response.isAxiosError) {
            notification.cadastroSucesso();
            enviarMensagem(response.data);
            await validarImpressaoRecibo(response.data);
            if (indiceSelecionado === 0) {
              initialCollapses();
              handleCancelar();
              history.push("/faturamento/ordem-servicos");
            } else {
              handleCancelar();
            }
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const formatarErroPagamentos = (error) => {
    const erroAbaPagamentos = error?.message?.includes("pagamento");
    if (erroAbaPagamentos) {
      setAbaValue(2);
    }
  };

  const handleCancelar = () => {
    ordemServicoEntity = new OrdemServico({
      dataAbertura: formatDate.toSend(new Date()),
    });
    ordemServicoEntity.setDescricaoServicoFixa(configuracaoOrdemServico);
    setHabilitarPagamentoPrazo(false);
    setOrdemServico({ ...ordemServicoEntity });
  };

  const onSearchChangePessoas = (event, inputRef, tiposPessoaId) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const filtros = montarFiltroPessoa(event.target?.value, tiposPessoaId);
      setLoadingAutoComplete(true);
      buscarPessoasPorTipo(filtros, tiposPessoaId);
    }
  };

  const buscarPessoasPorTipo = async (filtros, tiposPessoaId) => {
    const filtro = {
      ...filtros,
      tiposPessoaId,
      nonPaginated: true,
      ativado: true,
    };
    const tipoPessoaTemp = tiposPessoa.find(
      ({ tipoId }) => tipoId === tiposPessoaId,
    );
    const pessoas = await buscarPessoas(filtro);
    setLoadingAutoComplete(false);
    if (pessoas?.length) {
      tipoPessoaTemp?.setLista(pessoas);
    }
  };

  async function buscarPessoas(filtros) {
    const res = await pessoaService.getAll({
      ...filtros,
      attributes: [
        "id",
        "codigo",
        "nomeRazaoSocial",
        "apelidoFantasia",
        "cnpjCpf",
        "celular",
      ],
    });
    if (!res.isAxiosError) {
      return res.data;
    } else {
      responseErros(res);
    }
    return [];
  }

  const buscarProdutosSimilares = async (produtoId) => {
    if (produtoId) {
      produtosService.getById(produtoId).then((result) => {
        if (!result.isAxiosError) {
          setProdutosSimilares(result.data.similares);
        } else {
          responseErros(result);
        }
      });
    }
  };

  const buscarTodasTabelasVenda = async (pessoaId, intGrupoPessoaId) => {
    setLoading(true);
    try {
      const filtros = {
        ativado: true,
        nonPaginated: true,
        restritiva: true,
        tabelaRegente: true,
      };
      const response = await tabelaVendaService.getAll(filtros);
      if (response.isAxiosError) {
        responseErros(response);
        return;
      }
      const tabelasProcessadas = response.data.reduce(
        (acc, tabela) => {
          const pessoa = tabela?.pessoaIds.find(
            (tabelaPessoa) => tabelaPessoa.intPessoaId == pessoaId,
          );
          if (pessoa) {
            acc.cliente = tabela;
          } else if (tabela.intGrupoPessoaId === intGrupoPessoaId) {
            acc.grupoPessoa = tabela;
          } else {
            acc.todosProdutos = tabela;
          }
          return acc;
        },
        { cliente: null, grupoPessoa: null, todosProdutos: null },
      );
      setTabelas(tabelasProcessadas);
    } catch (error) {
      console.error("Erro ao buscar tabelas:", error);
    } finally {
      setLoading(false);
    }
  };

  const onChangeAutocompleteCliente = async (newValue) => {
    if (!newValue || (newValue && newValue.id !== clienteSelecionado?.id)) {
      setListaOrdemServicoPagamentos([]);
      ordemServicoEntity.setChangePagamentos([]);
      setGerarPagamentos((prevState) => ({
        ...prevState,
        valorTitulo: ordemServicoEntity?.totalOrdemServico,
      }));
    }
    ordemServicoEntity.setHandleChangeAutoComplete("clienteId", newValue);
    setOrdemServico((prevState) => ({
      ...ordemServicoEntity,
      statusInicial: prevState.statusInicial,
    }));
    setClienteSelecionado(newValue);
    await buscarDadosClientes(newValue?.id);
    if (newValue?.clientes?.length) {
      buscarTodasTabelasVenda(
        newValue?.id,
        newValue?.clientes?.[0]?.grupoPessoaId,
      );
    } else {
      setMeiosPagamentoCliente(null);
    }
  };

  const handleChangeInput = (event) => {
    ordemServicoEntity.setHandleChangeInput(
      event.target.name,
      event.target.value,
    );
    setOrdemServico((prevState) => ({
      ...ordemServicoEntity,
      statusInicial: prevState.statusInicial,
    }));
  };

  const handleChangeStatus = (event) => {
    const statusSelecionado = statusList.find(
      (status) => status.status == event.target.value,
    );

    if (statusSelecionado?.id) {
      ordemServicoEntity.setStatusPersonalizado(statusSelecionado.id);
      ordemServicoEntity.setStatus("ABERTO");
    } else {
      ordemServicoEntity.setStatus(event.target.value);
      ordemServicoEntity.setStatusPersonalizado(null);
      setHabilitarPagamentoPrazo(event.target.value === "FECHADO");
    }

    setOrdemServico((prevState) => ({
      ...ordemServicoEntity,
      statusInicial: prevState.statusInicial,
    }));
  };

  const handleCloseCadastroCliente = () => {
    buscarPessoasPorTipo();
    setOrdemServico((prevState) => ({
      ...ordemServicoEntity,
      statusInicial: prevState.statusInicial,
    }));
    setIsCadastroPessoaDialogOpen(false);
  };

  const buscarDadosClientes = async (clienteId) => {
    if (!clienteId) return;
    const result = await pessoaService.getById(clienteId);
    if (!result.isAxiosError) {
      setClienteSelecionado(result.data);
      buscarDocumentosCliente(clienteId);
      filterMeiosPagamentoCliente(result.data.clientes[0]);
      return result.data;
    } else {
      responseErros(result);
    }
  };

  const filterMeiosPagamentoCliente = (cliente) => {
    const list = meioPagamentoList?.length ? meioPagamentoList : [];
    if (cliente?.meiosPagamento?.length) {
      const meioPagamentoIds = cliente.meiosPagamento.map(
        ({ meioPagamentoId }) => meioPagamentoId,
      );
      const filterMeioPagamento = list?.filter((item) =>
        meioPagamentoIds.includes(item.id),
      );
      setMeiosPagamentoCliente(filterMeioPagamento);
      const meioPagamentoValido = meioPagamentoIds.find(
        (id) => id === gerarPagamentos?.meioPagamentoId,
      );
      if (gerarPagamentos?.meioPagamentoId && !meioPagamentoValido) {
        setGerarPagamentos((prevState) => ({
          ...prevState,
          meioPagamentoId: null,
          condicaoPagamentoId: null,
        }));
        setCondicaoPagParcelaList([]);
      }
    } else {
      setMeiosPagamentoCliente(null);
    }
  };

  const reabrirOs = () => {
    ordemServicoService.reabrir(id).then((response) => {
      if (!response.isAxiosError) {
        notification.sucessoGenericos("Ordem de serviço reaberta com sucesso");
        buscarDadosIniciais();
      } else {
        responseErros(response);
      }
    });
  };

  const cancelarOs = async () => {
    const retornoAlerta = await notification.confirmacao(
      "Cancelar!",
      "Tem certeza que deseja cancelar essa ordem de serviço?",
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await ordemServicoService.cancelar(id);
      if (!result.isAxiosError) {
        notification.alteracaoSucesso();
        buscarDadosIniciais();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  async function buscarOS() {
    setLoading(true);
    if (!id) {
      setLoading(false);
      return notification.alertaGenericos("Ordem de serviço não cadastrada");
    }
    const dadosEmpresaRelatorio = sessionService.getEmpresaRelatorio();
    const dto = new OrdemServicoPrintEntity(
      dadosEmpresaRelatorio,
      ordemServicoEntity.pagamentos,
      ordemServicoEntity.servicos,
      meioPagamentoList,
      prestadoresList,
      clienteSelecionado,
      configuracoes?.modeloImpressaoPadraoOs,
    );
    const result = await ordemServicoService.getOS(id, dto);
    setLoading(false);
    if (!result.isAxiosError) {
      if (configuracoes?.impressaoDiretaOs) {
        await print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function imprimirTermoAceiteChecklist() {
    if (!id) {
      return notification.alertaGenericos(
        "Cadastre a ordem de serviço para imprimir o termo de aceite",
      );
    }
    if (!acessoriosAtivo.length && !locaisAvaria.length) {
      return notification.alertaGenericos(
        "Nenhum checklist configurado para esta ordem de serviço",
      );
    }
    setLoading(true);
    const dto = new TermoAceitePrintEntity(
      sessionService.getEmpresa(),
      clienteSelecionado,
      acessoriosAtivo,
      locaisAvaria,
      tiposAvaria,
    );
    const result = await ordemServicoService.getTermoAceiteChecklist(id, dto);
    setLoading(false);
    if (!result.isAxiosError) {
      openAbaDanfeBase64(result.data);
    } else {
      responseErros(result);
    }
  }

  async function enviarMensagem(ordemServicoParams = {}, showModal = false) {
    try {
      const getPrimeiroNome = (nomeCompleto) => {
        return nomeCompleto?.split(" ")[0] || "";
      };
      const nomeCliente =
        clienteSelecionado?.nomeRazaoSocial ||
        dadosEmpresa?.cliente?.nomeRazaoSocial ||
        "";

      const stringAtivosFormatados = formatarAtivos(ordemServico?.ativos);

      const texto = await mensagemPersonalizadaService.getMensagem({
        ...ordemServico,
        ...ordemServicoParams,
        contexto: `ordem-servico-${statusSelectValue.toLocaleLowerCase()}`,
        apelidoFantasia: dadosEmpresa?.empresa?.apelidoFantasia,
        nomeCompletoCliente: nomeCliente,
        primeiroNomeCliente: getPrimeiroNome(nomeCliente),
        nomeUsuario: dadosEmpresa?.usuario?.nome || "",
        dataFechamento: format(
          formatDate.received(ordemServico?.dataFechamento),
          "dd/MM/yyyy",
        ),
        dataPrevistaFechamento: format(
          formatDate.received(ordemServico?.dataPrevistaFechamento),
          "dd/MM/yyyy",
        ),
        dataAbertura: format(
          formatDate.received(ordemServico?.dataAbertura),
          "dd/MM/yyyy",
        ),
        status: statusSelectValue,
        ativos: stringAtivosFormatados,
      });

      if (!texto.isAxiosError && texto?.data) {
        if (showModal) {
          modalConfirmacaoWhatsapp(clienteSelecionado, texto);
        } else {
          const result = await adzapService.enviarMensagem({
            number:
              clienteSelecionado?.celular ||
              dadosEmpresa?.cliente?.celular ||
              "",
            type: "text",
            text: texto?.data,
          });

          if (!result.isAxiosError) {
            notification.sucessoGenericos("Documento enviado com sucesso!");
          } else {
            responseErros(result);
          }
        }
      }
    } catch (error) {
      notification.erroGenericos("Falha no envio do documento");
    } finally {
      setLoading(false);
    }
  }

  async function openAbaDanfeBase64(base64Pdf) {
    try {
      const response = await fetch(`data:application/pdf;base64,${base64Pdf}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site",
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  async function print(base64Pdf) {
    setLoading(true);
    try {
      if (!base64Pdf) {
        notification.erroGenericos("Erro ao gerar imagem para impressão.");
        return;
      }
      const body = {
        base64Pdf,
        printerName: configuracoes?.impressoraTermica || null,
      };
      const resultImpressao = await impressoraService.imprimirTermicaPdf(body);
      if (!resultImpressao.isAxiosError) {
        notification.sucessoGenericos("Impressão realizada com sucesso!");
      } else {
        responseErros(resultImpressao);
      }
    } catch (error) {
      console.error("Erro na impressão:", error);
      notification.erroGenericos("Erro ao realizar a impressão.");
    } finally {
      setLoading(false);
    }
  }

  function formatarAtivos() {
    return (
      ordemServicoEntity?.ativos
        ?.filter((ativo) => ativo.ativado !== false)
        .map((ativo) => {
          const nomeDoAtivo = ativo.descricao || ativo.nome || "Ativo";
          let textoAtivo = `*${nomeDoAtivo}*`;

          if (ativo.camposPersonalizados?.length) {
            const campos = ativo.camposPersonalizados
              .filter((campo) => campo.value)
              .sort((a, b) => (a.ordem || 0) - (b.ordem || 0))
              .map((campo) => `${campo.label}: ${String(campo.value)}`)
              .join("\n");
            textoAtivo += `\n${campos}`;
          }
          return textoAtivo.toUpperCase();
        })
        .join("\n\n") || "NENHUM ATIVO VINCULADO."
    );
  }

  function formatObjetoParaMensagem(ordemServico) {
    const keys = Object.keys(ordemServico || {});
    for (const key of keys) {
      if (Array.isArray(ordemServico[key])) {
        delete ordemServico[key];
      }
    }
    return ordemServico;
  }

  function gerarLinkPesquisaSatisfacao() {
    if (envioMensagemManual) {
      return "<i>Link já enviado anteriormente! Caso já tenha respondido, favor desconsiderar esta seção.<i>";
    } else {
      const baseUrl = window.location.origin;
      const base = {
        empresaId: dadosEmpresa.empresa?.id,
        ordemServicoId: id,
        nomeFantasia: dadosEmpresa.empresa?.fantasia,
        cnpjCpf: dadosEmpresa.empresa?.cnpjCpf,
      };
      const basicData = encrypt(base);
      return `${baseUrl}/cadastros/pesquisa-satisfacao/${basicData}`;
    }
  }

  const enviarEmail = async () => {
    if (clienteSelecionado?.email) {
      setLoading(true);
      try {
        const getPrimeiroNome = (nomeCompleto) => {
          return nomeCompleto?.split(" ")[0] || "";
        };
        const nomeCliente = clienteSelecionado?.nomeRazaoSocial;
        const ordemServico = formatObjetoParaMensagem({
          ...ordemServicoEntity,
        });
        const stringAtivosFormatados = formatarAtivos();
        const linkPesquisaSatisfacao = gerarLinkPesquisaSatisfacao();
        const status = ordemServicoEntity?.statusPersonalizadoId
          ? statusList?.find(
              (s) => s.id == ordemServicoEntity?.statusPersonalizadoId,
            )?.status ?? ordemServicoEntity?.status
          : ordemServicoEntity?.status ?? "";

        const resultEmail = await emailPersonalizadoService.getInformacoesEmail(
          {
            ...ordemServico,
            contexto: `ordem-servico`,
            linkPesquisaSatisfacao,
            apelidoFantasia: dadosEmpresa?.empresa?.nome,
            nomeCompletoCliente: nomeCliente,
            primeiroNomeCliente: getPrimeiroNome(nomeCliente),
            nomeUsuario: dadosEmpresa.usuario?.nome,
            dataFechamento: format(
              formatDate.received(ordemServicoEntity?.dataFechamento),
              "dd/MM/yyyy",
            ),
            dataPrevistaFechamento: format(
              formatDate.received(ordemServicoEntity?.dataPrevistaFechamento),
              "dd/MM/yyyy",
            ),
            dataAbertura: format(
              formatDate.received(ordemServicoEntity?.dataAbertura),
              "dd/MM/yyyy",
            ),
            status,
            ativos: stringAtivosFormatados,
          },
        );

        if (resultEmail.isAxiosError) {
          const message = resultEmail?.response?.data?.message;
          throw new Error(message ?? "Erro interno de servidor");
        }

        const {
          subject = "Documento referente a Ordem de Serviço",
          text = "Segue ordem de serviço solicitada em anexo",
        } = resultEmail.data ?? {};

        const dadosEmpresaRelatorio = sessionService.getEmpresaRelatorio();
        const dto = new OrdemServicoPrintEntity(
          dadosEmpresaRelatorio,
          ordemServicoEntity.pagamentos,
          ordemServicoEntity.servicos,
          meioPagamentoList,
          prestadoresList,
          clienteSelecionado,
          configuracoes?.modeloImpressaoPadraoOs,
        );
        const result = await ordemServicoService.getOS(id, dto);
        if (result.isAxiosError) {
          const message = resultEmail?.response?.data?.message;
          throw new Error(message ?? "Erro interno de servidor");
        }

        const anexo = {
          filename: `Ordem-Servico_${ordemServico.serieDocumento}-${ordemServico.numeroDocumento}`,
          type: "application/pdf",
          content: result.data,
        };
        const resultEnvio = await notificacaoService.enviarEmail({
          to: clienteSelecionado.email,
          subject,
          text,
          attachments: [anexo],
        });
        if (!resultEnvio.isAxiosError) {
          notification.sucessoGenericos("Documento enviado com sucesso");
        } else {
          throw new Error("Erro ao enviar documento via email");
        }
      } catch (error) {
        console.error(error);
        notification.alertaGenericos(error.message);
      } finally {
        setLoading(false);
        initialCollapses();
        voltar();
      }
    } else {
      notification.alertaGenericos("Este cliente não possui e-mail cadastrado");
    }
  };

  const navegarAtePagamentos = () => {
    setAbaValue(2);
    setTimeout(() => {
      const ref = document?.getElementById("pagamentos-os");
      ref?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  const isFechado = id && ordemServico?.statusInicial === "FECHADO";
  const isCancelado = id && ordemServico?.statusInicial === "CANCELADO";
  const descricaoServicoBloqueada =
    !!configuracaoOrdemServico?.descricaoServicoFixa &&
    !configuracaoOrdemServico?.permiteEditarDescricaoServico;

  const statusSelectValue = ordemServico?.statusPersonalizadoId
    ? statusList.find((s) => s.id == ordemServico.statusPersonalizadoId)
        ?.status ?? ordemServico?.status
    : ordemServico?.status ?? "";

  const renderActions = () => {
    if (id) {
      return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {orcamentoServicoVinculado && (
            <Tooltip
              title={`Esta Ordem de Serviço foi gerada a partir do Orçamento de Serviço  ${
                orcamentoServicoVinculado.serieDocumento
                  ? `${orcamentoServicoVinculado.serieDocumento}/`
                  : "Nº "
              }${orcamentoServicoVinculado.numeroDocumento ?? ""}`}
              arrow
              placement="bottom"
            >
              <Chip
                color="default"
                variant="filled"
                size="small"
                label={"Importado"}
                sx={{ mr: 1 }}
              ></Chip>
            </Tooltip>
          )}
          {ordemServico?.statusInicial === "FECHADO" && (
            <>
              {listaOrdemServicoPesquisas?.length > 0 && (
                <ListPesquisaSatisfacaoOS
                  listaOrdemServicoPesquisas={listaOrdemServicoPesquisas}
                />
              )}

              <Tooltip title="Imprimir OS" arrow placement="left">
                <IconButton onClick={async () => await buscarOS()}>
                  <i
                    className="ph-fill ph-printer"
                    style={{ fontSize: 18 }}
                  ></i>
                </IconButton>
              </Tooltip>
            </>
          )}
          {permissoesHelper.temPermisao("ordem-servicos-cancelar") &&
            !isCancelado && (
              <Button
                variant="outlined"
                className="mb-1"
                size="small"
                color="primary"
                onClick={cancelarOs}
                disabled={ordemServico?.status !== "ABERTO"}
              >
                Cancelar OS
              </Button>
            )}
          <Tooltip title="Enviar por Email" arrow placement="bottom">
            <IconButton onClick={enviarEmail} sx={{ marginLeft: 1.5 }}>
              <i className="ph-fill ph-envelope" style={{ fontSize: 18 }}></i>
            </IconButton>
          </Tooltip>
          {dadosEmpresa.empresa.whatsappSimples && (
            <Tooltip title="Enviar por WhatsApp" arrow placement="bottom">
              <IconButton
                onClick={() => {
                  atualizarEntidadePrint();
                  setEnvioMensagemManual(true);
                  setOpenDialogEnvioWhatsapp(true);
                }}
                sx={{ marginLeft: 1 }}
              >
                <i
                  className="ph-fill ph-whatsapp-logo"
                  style={{ fontSize: 18, color: "#48A34C" }}
                ></i>
              </IconButton>
            </Tooltip>
          )}
        </Box>
      );
    } else {
      return <></>;
    }
  };

  return (
    <AddLayout
      id={id}
      title={id ? "Editar Ordem de Serviço" : "Cadastrar Ordem de Serviço"}
      showUpdate={
        permissoesHelper.temPermisao("ordem-servicos-editar") &&
        !(isFechado || isCancelado)
      }
      onClickSalvar={handleSubmit}
      loading={loading}
      codigo={id ? `Nº Documento ${ordemServico?.numeroDocumento}` : null}
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      actions={renderActions()}
      actionsTotalizadores={
        <ResumoTotal
          ordemServico={ordemServico}
          setOrdemServico={setOrdemServico}
          ordemServicoEntity={ordemServicoEntity}
          abaValue={abaValue}
          listaServicos={listaOrdemServicoServicos}
          setListaServicos={setListaOrdemServicoServicos}
          listaProdutos={listaOrdemServicoProdutos}
          setListaProdutos={setListaOrdemServicoProdutos}
        />
      }
    >
      <Grid container spacing={2} columns={16}>
        <Grid item xs={1}>
          <TextField
            id="serieDocumento"
            name="serieDocumento"
            label="Série"
            variant="outlined"
            margin="normal"
            disabled
            value={ordemServico?.serieDocumento ?? ""}
            fullWidth
          />
        </Grid>
        <Grid item xs={1.5}>
          <TextField
            id="numeroDocumento"
            name="numeroDocumento"
            type="number"
            label="Nº Documento"
            variant="outlined"
            margin="normal"
            disabled
            value={ordemServico?.numeroDocumento ?? ""}
            InputProps={{ inputProps: { min: 0 } }}
            fullWidth
          />
        </Grid>
        <Grid item xs={5}>
          <FormControl
            variant="outlined"
            margin="normal"
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <Autocomplete
              id="clienteId"
              name="clienteId"
              options={clienteList}
              autoHighlight
              getOptionLabel={(option) => {
                let codigoPessoa = option?.codigo ? `${option.codigo} - ` : "";
                let descricaoPessoa =
                  codigoPessoa + `${option.nomeRazaoSocial}`;
                return option ? descricaoPessoa : "";
              }}
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText={
                document.getElementById("clienteId")?.value?.length ? (
                  <Grid container spacing={1}>
                    <Grid item xs={12} fullWidth>
                      Nenhum cliente encontrado
                    </Grid>
                  </Grid>
                ) : (
                  "Digite e pressione Enter"
                )
              }
              disabled={isFechado || isCancelado}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={"Cliente"}
                  error={inputErros.get("clienteId")}
                  required
                  disabled={isFechado || isCancelado}
                  variant={"outlined"}
                  onKeyDown={(e) => onSearchChangePessoas(e, inputCliente, 1)}
                  inputRef={inputCliente}
                  inputProps={{ ...params.inputProps, enterKeyHint: "search" }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <EndAdornmentCliente
                        params={params}
                        loading={loadingAutoComplete}
                        clienteSelecionado={clienteSelecionado}
                      />
                    ),
                  }}
                />
              )}
              onChange={(_, newValue) => onChangeAutocompleteCliente(newValue)}
              value={clienteSelecionado}
            />
            <Tooltip title="Cadastrar Cliente" arrow placement="bottom">
              <Button
                id="buttonAdicionarCliente"
                variant="contained"
                disabled={isFechado || isCancelado}
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => setIsCadastroPessoaDialogOpen(true)}
              >
                <i
                  className="ph-bold ph-plus"
                  style={{ color: "#fff", fontSize: 15 }}
                />
              </Button>
            </Tooltip>
            {!id && ordemServico?.clienteId && ordemServicos?.length ? (
              <>
                {loadingHistorico ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  <>
                    <Tooltip
                      title="Visualizar Histórico Cliente"
                      arrow
                      placement="bottom"
                    >
                      <Button
                        id="buttonHistoricoCliente"
                        variant="contained"
                        disabled={!ordemServico?.clienteId}
                        size="small"
                        sx={{
                          height: "35px",
                          borderRadius: "20%",
                          minWidth: "15px",
                          boxShadow: "none",
                        }}
                        onClick={() => {
                          setOpenHistoricoClienteDialog(true);
                        }}
                      >
                        <i
                          className="ph-fill ph-shopping-cart"
                          style={{ fontSize: 15, color: "white" }}
                        ></i>
                      </Button>
                    </Tooltip>
                    <Tooltip
                      title="Visualizar Histórico de Ativos"
                      arrow
                      placement="bottom"
                    >
                      <Button
                        id="buttonHistoricoAtivos"
                        variant="contained"
                        disabled={!ordemServico?.clienteId}
                        size="small"
                        sx={{
                          height: "35px",
                          borderRadius: "20%",
                          minWidth: "15px",
                          boxShadow: "none",
                        }}
                        onClick={() => setOpenHistoricoAtivosDialog(true)}
                      >
                        <i
                          className="ph-fill ph-toolbox"
                          style={{ fontSize: 15, color: "white" }}
                        ></i>
                      </Button>
                    </Tooltip>
                  </>
                )}
              </>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={ordemServico?.dataFechamento ? 2 : 3}>
          <DatePicker
            key={dataAberturaResetRef.current}
            id="dataAbertura"
            name="dataAbertura"
            label="Data de Abertura"
            format="dd/MM/yyyy"
            margin
            required
            disabled={isFechado || isCancelado}
            value={
              ordemServico?.dataAbertura ? ordemServico.dataAbertura : null
            }
            onChange={(date) => {
              setInputErro([]);
              handleDateChange("dataAbertura", date);
            }}
            error={inputErros.get("dataAbertura")}
          />
        </Grid>
        <Grid item xs={ordemServico?.dataFechamento ? 2 : 3}>
          <DatePicker
            id="dataPrevistaFechamento"
            name="dataPrevistaFechamento"
            label="Previsão de Fechamento"
            format="dd/MM/yyyy"
            margin
            required
            disabled={isFechado || isCancelado}
            value={
              ordemServico?.dataPrevistaFechamento
                ? ordemServico.dataPrevistaFechamento
                : null
            }
            onChange={(date) => {
              setInputErro([]);
              handleDateChange("dataPrevistaFechamento", date);
            }}
            error={inputErros.get("dataPrevistaFechamento")}
          />
        </Grid>
        {ordemServico?.dataFechamento && (
          <Grid item xs={2}>
            <DatePicker
              id="dataFechamento"
              name="dataFechamento"
              label="Data de Fechamento"
              format="dd/MM/yyyy"
              margin
              disabled
              value={ordemServico.dataFechamento}
              error={inputErros.get("dataFechamento")}
            />
          </Grid>
        )}
        <Grid item xs={2.5}>
          <Select
            id="status"
            name="status"
            label="Status"
            variant="outlined"
            margin="normal"
            value={statusSelectValue}
            onChange={handleChangeStatus}
            fullWidth
            disabled={isFechado || isCancelado || !id}
            disableClearable
            InputProps={{
              startAdornment: (
                <>
                  {id && isFechado && (
                    <InputAdornment position="start">
                      <Tooltip
                        placement="top"
                        title="Reabrir Ordem de Serviço"
                        arrow
                      >
                        <Button
                          color="padrao"
                          onClick={reabrirOs}
                          sx={{
                            minWidth: "15px",
                            padding: "5px",
                            boxShadow: "none",
                          }}
                        >
                          <i
                            className="ph-fill ph-lock-simple-open"
                            style={{ fontSize: "18px" }}
                          ></i>
                        </Button>
                      </Tooltip>
                    </InputAdornment>
                  )}
                </>
              ),
            }}
          >
            {statusList
              .filter(
                (s) =>
                  s.status !== "CANCELADO" ||
                  ordemServico?.status === "CANCELADO",
              )
              .map((status, index) => (
                <MenuItem key={index} value={status.status}>
                  <div className="d-flex align-items-center justify-content-between">
                    {status.status}&nbsp;
                    {status?.cor && (
                      <i
                        className="ph-fill ph-circle"
                        style={{ color: `${status.cor}` }}
                      ></i>
                    )}
                  </div>
                </MenuItem>
              ))}
          </Select>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AtivosOrdemServico
            setOrdemServico={setOrdemServico}
            ordemServicoEntity={ordemServicoEntity}
            ordemServicos={ordemServicos}
            isFechado={isFechado || isCancelado}
            somenteLeitura={!!id}
          />
        </Grid>
        <Grid item xs={12}>
          <ChecklistOrdemServico
            ordemServicoEntity={ordemServicoEntity}
            ordemServico={ordemServico}
            setOrdemServico={setOrdemServico}
            acessoriosAtivo={acessoriosAtivo}
            setAcessoriosAtivo={setAcessoriosAtivo}
            locaisAvaria={locaisAvaria}
            setLocaisAvaria={setLocaisAvaria}
            tiposAvaria={tiposAvaria}
            avariaSelecionada={avariaSelecionada}
            setAvariaSelecionada={setAvariaSelecionada}
            isFechado={isFechado || isCancelado}
            somenteLeitura={checklistSomenteLeitura}
            loading={loading}
            handleChangeInput={handleChangeInput}
            onImprimirTermoAceite={imprimirTermoAceiteChecklist}
            permiteImprimirTermoAceite={!!id}
          />
        </Grid>
        {(configuracoes?.exibirDescricaoServico ||
          configuracaoOrdemServico?.descricaoServicoFixa) && (
          <Grid item xs={12}>
            <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
              Descrição do Serviço
            </Typography>
            <TextareaAutosize
              id="observacoes"
              name="observacoes"
              className="textRolagem bg-transparent"
              label="Observacao"
              maxLength={550}
              disabled={isFechado || isCancelado || descricaoServicoBloqueada}
              value={ordemServico?.observacoes}
              onChange={handleChangeInput}
            />
          </Grid>
        )}
      </Grid>

      <hr className="mt-4 mb-2" />

      <Grid item xs={12}>
        <Paper>
          <Tabs
            value={abaValue}
            onChange={(e, newValue) => setAbaValue(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="SERVIÇOS" {...tabProps(0)} />
            <Tab label="PRODUTOS" {...tabProps(1)} />
            <Tab label="PAGAMENTOS" {...tabProps(2)} disabled={isCancelado} />
          </Tabs>
        </Paper>

        <CardContent>
          <TabPanel value={abaValue} index={0}>
            <OrdemServicoListaServicos
              id={id}
              ordemServico={ordemServico}
              setOrdemServico={setOrdemServico}
              ordemServicoEntity={ordemServicoEntity}
              servicoList={servicoList}
              setServicoList={setServicoList}
              prestadoresList={prestadoresList}
              removerServicoCadastrado={removerServicoCadastrado}
              listaOrdemServicoPagamentos={listaOrdemServicoPagamentos}
              setListaOrdemServicoPagamentos={setListaOrdemServicoPagamentos}
              listaOrdemServicoServicos={listaOrdemServicoServicos}
              setListaOrdemServicoServicos={setListaOrdemServicoServicos}
              permissaoAlterarValorServico={permissaoAlterarValorServico}
              isFechado={isFechado}
              isCancelado={isCancelado}
            />
          </TabPanel>

          <TabPanel value={abaValue} index={1}>
            <OrdemServicoListaProdutos
              id={id}
              setOrdemServico={setOrdemServico}
              produtoList={produtoList}
              setProdutoList={setProdutoList}
              listaOrdemServicoProdutos={listaOrdemServicoProdutos}
              setListaOrdemServicoProdutos={setListaOrdemServicoProdutos}
              removerProdutoCadastrado={removerProdutoCadastrado}
              setLoading={setLoading}
              ordemServico={ordemServico}
              ordemServicoEntity={ordemServicoEntity}
              buscarProdutosSimilares={buscarProdutosSimilares}
              produtosSimilares={produtosSimilares}
              setProdutosSimilares={setProdutosSimilares}
              produto={produto}
              setProduto={setProduto}
              meioPagamentoSelecionado={meioPagamentoSelecionado}
              acrescimoPagamento={acrescimoPagamento}
              tabelas={tabelas}
              listaOrdemServicoPagamentos={listaOrdemServicoPagamentos}
              vendedoresList={vendedoresList}
              setVendedoresList={setVendedoresList}
              usuariosList={usuariosList}
              configuracoes={configuracoes}
              permissaoAlterarVendedor={permissaoAlterarVendedor}
              permissaoAlterarValorProduto={permissaoAlterarValorProduto}
              isProdutoEdit={isProdutoEdit}
              setIsProdutoEdit={setIsProdutoEdit}
              isFechado={isFechado}
              isCancelado={isCancelado}
              enderecosEstoqueList={enderecosEstoqueList}
            />
          </TabPanel>

          <TabPanel value={abaValue} index={2}>
            <div id="pagamentos-os">
              <OrdemServicoListaPagamentos
                id={id}
                configuracoes={configuracoes}
                ordemServico={ordemServico}
                setOrdemServico={setOrdemServico}
                listaOrdemServicoPagamentos={listaOrdemServicoPagamentos}
                setListaOrdemServicoPagamentos={setListaOrdemServicoPagamentos}
                condicaoPagamentoList={condicaoPagamentoList}
                gerarPagamentos={gerarPagamentos}
                setGerarPagamentos={setGerarPagamentos}
                condicaoSelecionada={condicaoSelecionada}
                setCondicaoSelecionada={setCondicaoSelecionada}
                condicaoPagParcelaList={condicaoPagParcelaList}
                setCondicaoPagParcelaList={setCondicaoPagParcelaList}
                meioPagamentoList={meioPagamentoList}
                meiosPagamentoCliente={meiosPagamentoCliente}
                ordemServicoEntity={ordemServicoEntity}
                meioPagamentoSelecionado={meioPagamentoSelecionado}
                setMeioPagamentoSelecionado={setMeioPagamentoSelecionado}
                listaOrdemServicoProdutos={listaOrdemServicoProdutos}
                setListaOrdemServicoProdutos={setListaOrdemServicoProdutos}
                setAcrescimoPagamento={setAcrescimoPagamento}
                produto={produto}
                setProduto={setProduto}
                removerPagamentoCadastrado={removerPagamentoCadastrado}
                isFechado={isFechado || isCancelado}
                habilitarPagamentoPrazo={habilitarPagamentoPrazo}
                setReciboPagamentos={setReciboPagamentos}
              />
            </div>
          </TabPanel>
        </CardContent>
      </Grid>
      <div style={{ display: "none" }}>
        <div ref={printComponentRef}>
          <ReciboPrintLayout
            data={{
              cliente: clienteSelecionado,
              pagamentos: reciboPagamentos,
            }}
          />
        </div>
      </div>
      <HistorioClienteDialog
        open={openHistoricoClienteDialog}
        setOpen={setOpenHistoricoClienteDialog}
        clienteId={ordemServico?.clienteId}
        totalItems={totalItems}
        setTotalItems={setTotalItems}
        prestadoresList={prestadoresList}
        statusList={statusList}
        ordemServicoEntity={ordemServicoEntity}
        setOrdemServico={setOrdemServico}
        campoChave={campoChave}
        setListaOrdemServicoProdutos={setListaOrdemServicoProdutos}
        setListaOrdemServicoServicos={setListaOrdemServicoServicos}
      />
      <HistoricoAtivosDialog
        open={openHistoricoAtivosDialog}
        setOpen={setOpenHistoricoAtivosDialog}
        cliente={clienteSelecionado}
        ordemServicos={ordemServicos}
        ordemServicoEntity={ordemServicoEntity}
        setOrdemServico={setOrdemServico}
      />
      <FullscreenDialog
        open={isCadastroPessoaDialogOpen}
        handleClose={handleCloseCadastroCliente}
        content={
          <AddPessoas
            match={{ params: { id: null } }}
            isFullscreenDialog
            onChangeCliente={onChangeAutocompleteCliente}
            handleCloseFullscreenDialog={handleCloseCadastroCliente}
          />
        }
      />
      <EnvioWhatsappDialog
        open={openDialogEnvioWhatsapp}
        setOpen={setOpenDialogEnvioWhatsapp}
        envioMensagemManual={envioMensagemManual}
        setEnvioMensagemManual={setEnvioMensagemManual}
        data={{
          id,
          cliente: clienteSelecionado,
          empresa: dadosEmpresa?.empresa,
          imagemLogo: dadosEmpresa?.empresa?.imagemLogo,
          numeroDocumento: ordemServicoEntity?.numeroDocumento,
          statusList,
          dto: ordemServicoPrintEntity,
          ordemServico: ordemServicoEntity,
        }}
        formatarAtivos={formatarAtivos}
        formatObjetoParaMensagem={formatObjetoParaMensagem}
        gerarLinkPesquisaSatisfacao={gerarLinkPesquisaSatisfacao}
        initialCollapses={initialCollapses}
      />
    </AddLayout>
  );
};

export default AddOrdemServico;
